export const environment = {
  production: false,
  keycloakUrl: 'https://auth-dev.garajet.it/',
  realm: 'garajet',
  clientId: 'garajet-backoffice',
  gatewayBaseUrl: 'https://dev-api.garajet.it',
};
